// extracted by mini-css-extract-plugin
export default {"subtitle":"index_subtitle__Wcvq1","colgrey":"index_colgrey__GYoOw","title":"index_title__fImb8","row":"index_row__+ayCr"};